import { IconNames } from '@blueprintjs/icons';
import { DropdownMenu } from '@strata/react-dropdown-menu';
import { Icon } from '@strata/react-status-icons';
import classNames from 'classnames';
import { ComponentProps, useState } from 'react';

type ReferralRowMenuProps = Pick<ComponentProps<typeof DropdownMenu>, 'menuItemArray'>;

export const ReferralRowMenu = ({ menuItemArray = undefined }: ReferralRowMenuProps) => {
    const [showDropdown, setShowDropdown] = useState(false);

    return (
        <DropdownMenu
            isOpen={showDropdown}
            menuItemArray={menuItemArray}
            onInteraction={(nextOpenState, e) => {
                e?.stopPropagation();
                setShowDropdown(nextOpenState);
            }}
        >
            <Icon
                icon={IconNames.MORE}
                intent={Icon.Intent.SECONDARY}
                title="Referral Menu"
                className={classNames(
                    'sds_referral-grid-row__menu-button',
                    'padding__around--x-small',
                )}
            />
        </DropdownMenu>
    );
};
